import { render, staticRenderFns } from "./additionalInformation.vue?vue&type=template&id=1b46e208"
import script from "./additionalInformation.vue?vue&type=script&lang=js"
export * from "./additionalInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports